import React, { Component } from 'react';
import { auth } from '../../firebase';

export default class Admin extends Component {
  constructor (props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      errors: {}
    };
  }

  componentWillMount () {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.setState({
          authenticated: true,
          currentUser: user,
          loading: false
        });
      } else {
        this.setState({
          authenticated: false,
          currentUser: null,
          loading: false
        });
      }
    });

  }

  validation (e) {
    //console.log(this.state)
    var errors = {}

    // 半角英数字8文字以上、アルファベット・数字・記号を組み合わせた文字列
    const regexp = /^(?=.*?[a-z])(?=.*?\d)(?=.*?[!-/:-@[-`{-~])[!-~]{8,100}$/i;
    if (!this.state.password.match(regexp)) {
      errors["password"] = "パスワードを正しく入力してください。";
    } else if (this.state.email === this.state.password) {
      errors["password"] = "パスワードを正しく入力してください。";
    }

    this.setState({errors: errors}, () => {
      if (Object.keys(this.state.errors).length === 0) {
        this.send()
      }
    });
  }

  send(e) {
    var scope = this
    var errors = {}
    auth.signInWithEmailAndPassword(this.state.email, this.state.password).then(user => {
      // ログイン成功
      window.location.href = "/admin_users";
    }, err => {
      // エラーを表示する等
      errors["password"] = "メールアドレスまたはパスワードを正しく入力してください。";
      scope.setState({errors: errors});
    });
  }

  render () {
    return <div className="page home">
      <div className="content-wrapper">
        <div className="contents admin-login-wrapper">
          <div className="admin-login">
            <img src="/images/logo.png" className="logo" alt="logo" />
            <p><input type="text" name="email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} className="admin-login-form" placeholder="メールアドレス" /></p>
            <p><input type="password" name="password" value={this.state.password} onChange={e => this.setState({password: e.target.value})} className="admin-login-form" placeholder="パスワード" /></p>
            <p className="error-message">{this.state.errors.password}</p>
            <input type="button" onClick={this.validation.bind(this)} value="ログイン" className="admin-login-button" />
          </div>
        </div>
      </div>
    </div>;
  }
}